import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";

export const StyledTypographyHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledFieldLabelTypography = styled(Typography)(() => ({
  fontSize: "1rem",
  fontWeight: 600,
}));

export const StyledFieldValueTypography = styled(Typography)(() => ({
  fontWeight: 400,
}));

export const StyledAccountSettingsHeader = styled(Typography)(({ theme }) => ({
  fontSize: "23px",
  color: "#696969",
  textTransform: "uppercase",
  display: "block",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const StyledPasswordDisplayStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

export const StyledLoginInformationBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(8),
}));
